import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { NgxEchartsModule } from 'ngx-echarts';
import { ButtonToggleSelectModule, CalendarPickerModule, KeyValueBlockModule } from 'ngx-zcs-components';

import { EvchargeEnergyAggregationComponent } from './evcharge-energy-aggregation.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    EvchargeEnergyAggregationComponent,
  ],
  imports: [
    BlockTitleComponent,
    ButtonToggleSelectModule,
    CalendarPickerModule,
    CommonModule,
    IonicModule,
    KeyValueBlockModule,
    MatIconModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
  ],
  exports: [
    EvchargeEnergyAggregationComponent,
  ],
})
export class EvchargeEnergyAggregationModule { }
